var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"titulo\">\r\n    <h2> <strong>Llegaste al límite de notas sin cargo.</strong> Suscribite para seguir leyendo. </h2>\r\n    <p class=\"titulo__bajada\">Valorás el periodismo confiable. Te queremos en LA NACION.</p>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/header/limite_notas.hbs
// module id = 519
// module chunks = 0